module.exports = __webpack_public_path__ + "static/media/pasie.9e9b05c4.jpg";